export default __webpack_public_path__ + "static/media/2.efaa91e2.png";